// extracted by mini-css-extract-plugin
export var acceptCookieButton = "layout-module--accept-cookie-button--4b119";
export var buttonWrapperClasses = "layout-module--button-wrapper-classes--c4854";
export var buttonhover = "layout-module--buttonhover--34038";
export var container = "layout-module--container--46809";
export var content = "layout-module--content--1704e";
export var cookieBackground = "layout-module--cookie-background--26aa6";
export var cookieBanner = "layout-module--cookie-banner--d66e7";
export var cookieButton = "layout-module--cookie-button--921f0";
export var cookieList = "layout-module--cookie-list--c7faf";
export var wrapperClasses = "layout-module--wrapper-classes--adb9c";